module.exports = __webpack_public_path__ + "img/fast-master.4a0636ee.png";